import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SAMLLoginComponent } from './saml-login/saml-login.component';
import { LoginUserComponent } from './login-user/login-user.component';
import { GuestUserComponent } from './guest-user/guest-user.component';
import { PublicUserComponent } from './public-user/public-user.component';


const routes: Routes = [
  { path: 'ssologin', component: SAMLLoginComponent },
  { path: 'login-user', component: LoginUserComponent },
  { path: 'guest-user', component: GuestUserComponent },
  { path: 'public-user', component: PublicUserComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
